import React from 'react';
import { Box, ModuleSection, ResponsiveImage, Stack } from '@/components';
import { ImageModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import { colorFromBgColor } from '@/utils';
import { fadeIn } from '@/animations';

type ThreeCardContentModel = ModuleBaseModel<
  {
    cards: {
      itemName: string;
      image?: ImageModel;
      subtitle?: string;
      title?: string;
      text?: string;
      backgroundColour?: string;
    }[];
  } & ModuleSectionPropsModel
>;

const ThreeCardContent = (data: ThreeCardContentModel) => {
  const { cards } = data.props;

  return (
    <ModuleSection data={data}>
      <Stack className="container flex flex-col gap-2 md:flex-row md:gap-6 print:hidden">
        {[0, 1, 2].map((index) => (
          <Box animation={fadeIn} key={index} className="flex w-full flex-col">
            {cards[index] && cards[index].image && (
              <div className="aspect-[456/257] shrink-0">
                <ResponsiveImage
                  image={cards[index].image}
                  widths={{ xs: 335, sm: 261, md: 335, lg: 366, xl: 424, xxl: 456 }}
                  heights={{ xs: 187, sm: 147, md: 187, lg: 206, xl: 238, xxl: 257 }}
                />
              </div>
            )}

            {cards[index] && (
              <div
                className="flex w-full flex-col px-3 pt-5 pb-2"
                style={{
                  color: colorFromBgColor(cards[index].backgroundColour) || undefined,
                  backgroundColor: cards[index].backgroundColour,
                }}
              >
                {cards[index].subtitle && <p className="text-xs leading-[18px] font-medium">{cards[index].subtitle}</p>}
                {cards[index].title && <h4 className="py-5 text-xl leading-[26px]">{cards[index].title}</h4>}
                {cards[index].text && (
                  <div
                    className="[&_a]:text-report-link [&_a]:visited:text-report-visited-link [&_p]:mb-4"
                    dangerouslySetInnerHTML={{ __html: cards[index].text }}
                  />
                )}
              </div>
            )}
          </Box>
        ))}
      </Stack>
    </ModuleSection>
  );
};

export default ThreeCardContent;
